// IMPORTANT - if there are changes inside the defaultLayout object, OFFER_DETAILS_LAYOUT_KEY "V#" value needs to be incremented!!!

const OFFER_DETAILS_LAYOUT_KEY = "OFFER_DETAILS_LAYOUT_V6";
const userBoxHeight = 14;
const defaultLayout = {
    lg: [
        {
            i: "1",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: 0,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            isResizable: true,
            static: true,
            minW: 12,
            maxW: 12,
        },
        {
            i: "2",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: 0,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            minW: 12,
            maxW: 12,
        },
        {
            i: "3",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: 0,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            minW: 12,
            maxW: 12,
        },
    ],
    md: [
        {
            i: "1",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: 0,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            isResizable: true,
            static: true,
            minW: 8,
            maxW: 12,
        },
        {
            i: "2",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: 0,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            minW: 4,
            maxW: 12,
        },
        {
            i: "3",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: 0,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            minW: 12,
            maxW: 12,
        },
    ],
    sm: [
        {
            i: "1",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: 0,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            isResizable: true,
            static: true,
            minW: 8,
            maxW: 12,
        },
        {
            i: "2",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: 0,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            minW: 4,
            maxW: 12,
        },
        {
            i: "3",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: 0,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            minW: 4,
            maxW: 12,
        },
    ],
    xs: [
        {
            i: "1",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: 0,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            isResizable: true,
            static: true,
            minW: 12,
            maxW: 12,
        },
        {
            i: "2",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: userBoxHeight,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            minW: 12,
            maxW: 12,
        },
        {
            i: "3",
            w: 12,
            h: userBoxHeight,
            x: 0,
            y: userBoxHeight * 2,
            maxH: userBoxHeight,
            minH: userBoxHeight,
            isDraggable: false,
            minW: 12,
            maxW: 12,
        },
    ],
};
const defaultTableSize = 5;

export { OFFER_DETAILS_LAYOUT_KEY, defaultLayout, defaultTableSize };
